// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/no-onchange */
import React, { PureComponent, ReactNode } from "react"
import ChevronDown from "@kiwicom/orbit-components/lib/icons/ChevronDown"
import classnames from "classnames"
import * as R from "ramda"
import Translate from "../../NitroTranslate/components/NitroTranslate"

import fieldValidation from "../../utils/fieldValidation"

const omittedProps = [
  "options",
  "initialValue",
  "autofill",
  "onUpdate",
  "valid",
  "invalid",
  "dirty",
  "pristine",
  "error",
  "active",
  "touched",
  "visited",
  "autofilled",
]
type Props = {
  value?: string
  onChange?: (arg1: string) => void
  options: {
    value: string
    label: string
  }[]
  label: ReactNode
  error?: string
  touched?: boolean
  required?: boolean
  placeholder?: string
  disabled?: boolean
}

export default class NewSelectField extends PureComponent<Props> {
  static defaultProps = {
    disabled: false,
  }

  renderError = (error: string) => {
    return (
      <div className="spField-error">
        <span className="spField-note spTypo-note">
          <Translate t={error} />
        </span>
      </div>
    )
  }

  renderLabel = (label: ReactNode, required?: boolean) => {
    return (
      <div className="spField-label">
        {label}
        {required && "*"}
      </div>
    )
  }

  render() {
    const {
      value,
      error,
      label,
      touched,
      onChange,
      options,
      required,
      placeholder,
      disabled,
    } = this.props

    const validation = fieldValidation({
      error: Boolean(error) && touched,
      ok: !error && touched,
    })

    const classes = classnames("NewSelectField", "spField", validation.className, {
      _hasLabel: label,
      _notSelected: !value,
      _twoLines: label,
      _oneLine: !label,
      _disabled: disabled,
    })

    return (
      <div className={classes}>
        {label && validation.icon}
        <label>
          {this.renderLabel(label, required)}
          {error && touched && this.renderError(error)}

          <div className="spField-input">
            <select
              {...R.omit(omittedProps, this.props)}
              // Fix this the next time the file is edited. (Flow to TS)
              // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
              value={value || ""}
              // Fix this the next time the file is edited. (Flow to TS)
              // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
              onChange={(ev) => onChange && onChange(ev.target.value)}
              disabled={disabled}
            >
              {placeholder && (
                <option value="" disabled>
                  {placeholder}
                </option>
              )}
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <ChevronDown ariaHidden className="NewSelectField-icon-open" />
          </div>
        </label>
      </div>
    )
  }
}
